import { useEffect, useMemo } from "react";
// import { signRequest } from "../core/api/client";
import { client as shaneClient } from "../client/services.gen";
import { baseApiUrl } from "../const";
import { useAppState } from "../core/appState/UseAppStateZustand";

interface UseShaneClientProps {
  token?: string;
}

interface UseShaneClientReturn {
  shaneClient: typeof shaneClient;
}

export function useShaneClient({
  token,
}: UseShaneClientProps = {}): UseShaneClientReturn {

  const accessToken = useAppState(state => state.accessToken);

  // const interceptorAdded = useRef(false);

  useEffect(() => {
    shaneClient.setConfig({
      baseUrl: baseApiUrl,
      headers: {
        Authorization: `Bearer ${token || "<default_token>"}`,
      },
    });
  
    // if (!interceptorAdded.current) {
    //   shaneClient.interceptors.request.use((request: Request) => {
    //     const handleRequest = async () => {
    //       const url = new URL(request.url);
    //       const host = url.hostname;
  
    //       const newHeaders = new Headers(request.headers);
    //       newHeaders.set("Host", host);
    //       newHeaders.set("authorization", "Bearer " + accessToken);
  
    //       return new Request(request.url, {
    //         ...request,
    //         headers: newHeaders,
    //       });
    //     };
  
    //     return handleRequest();
    //   });
  
    //   interceptorAdded.current = true;
    // }
  }, [token, accessToken]);
  

  const memoizedReturn = useMemo(() => ({ shaneClient }), []);

  return memoizedReturn;
}
